module.exports = __webpack_public_path__ + "static/3- Bombus spp-cc188f3d4a316395feeb36e25a1eb9eb.jpg";